import { DealType, DealTypeLabel } from 'components/common/types/Deal.types';

export const getDealTypeLabel = (dealType) => {
  if (!dealType) return '';

  const dealTypeKey = Object.keys(DealType).find((key) => DealType[key] === dealType);

  return DealTypeLabel[dealTypeKey] ?? '';
};
